module.exports = __webpack_public_path__ + "img/user.b670acd8.svg";